import { render, staticRenderFns } from "./MobileView.vue?vue&type=template&id=22b15aad&"
import script from "./MobileView.vue?vue&type=script&lang=js&"
export * from "./MobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports